import { FormControl, FormHelperText, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { isNotNull } from '../../../features/common/util.services';
import './i-textfield.component.scss';

export type ITextFieldProps = {
    label: string;
    name: string;
    type?: string;
    onActionEvent?: any;
    InputProps?: any;
    disabled?: boolean;
    required?: boolean;
    rules?: any;
}

const ITextField = (props: ITextFieldProps) => {
    const { control, register, setValue } = useFormContext();
    const onActionEvent = (e: any) => {
        const value = e.target.value;
        setValue(props.name, value);
        if (props.onActionEvent) {
            props.onActionEvent(e);
        }
    }

    return <div className="i-textfield">
        <Controller
            control={control}
            name={props.name}
            rules={{
                required: {
                    value: props.required,
                    message: "Required Field"
                },
                ...props.rules
            }}
            render={({ field, fieldState }) => (<FormControl fullWidth>
                <TextField
                    {...field}
                    {...register(props.name)}
                    type={props.type}
                    size="small"
                    onChange={onActionEvent}
                    label={props.label}
                    disabled={props.disabled}
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    required={props.required}
                    InputProps={props.InputProps}
                    sx={{ '& input': { textOverflow: 'ellipsis' } }}
                    // helperText={fieldState.error ? fieldState.error.message : null}
                /> <FormHelperText error={isNotNull(fieldState.error)}>{fieldState.error ? fieldState.error.message : null}</FormHelperText>  </FormControl>
            )}
        />

    </div>

};

export default ITextField;